import type { Quantity } from '@personly/libs-types';

interface Props {
  quantity: Quantity;
  decimalPlaces?: number;
}

const QuantityView = ({ quantity, decimalPlaces = 2 }: Props) => (
  <>
    {quantity.value.toFixed(decimalPlaces)} {quantity.measure.assetHandle}
  </>
);

export default QuantityView;
